import { render } from "./404page.vue?vue&type=template&id=bd022d0a&scoped=true"
import script from "./404page.vue?vue&type=script&lang=js"
export * from "./404page.vue?vue&type=script&lang=js"

import "./404page.vue?vue&type=style&index=0&id=bd022d0a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/policies/policies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd022d0a"]])

export default __exports__